// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let FormalityUI = require("../common/Form/FormalityUI.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let AgentMarketingProfileBasicInfoSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfileBasicInfoSettingsQuery_graphql.bs.js");
let AgentMarketingProfileBasicInfoSettingsMutation_graphql = require("../../__generated__/AgentMarketingProfileBasicInfoSettingsMutation_graphql.bs.js");
let AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.bs.js");

let validators_brokerage = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let brokerage = param.brokerage;
    if (brokerage === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Ok",
        _0: brokerage
      };
    }
  }
};

let validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let website = param.website;
    if (website === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let e = Scalars.URL.fromString(website);
    if (e.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(e._0)
      };
    } else {
      return {
        TAG: "Error",
        _0: "InvalidURL"
      };
    }
  }
};

let validators_licenseNumber = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let licenseNumber = param.licenseNumber;
    if (licenseNumber === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Ok",
        _0: licenseNumber
      };
    }
  }
};

let validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let lastName = param.lastName;
    if (lastName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: lastName
      };
    }
  }
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let firstName = param.firstName;
    if (firstName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: firstName
      };
    }
  }
};

let validators = {
  brokerage: validators_brokerage,
  website: validators_website,
  licenseNumber: validators_licenseNumber,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(input) {
  return {
    brokerage: "Pristine",
    website: "Pristine",
    licenseNumber: "Pristine",
    lastName: "Pristine",
    firstName: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.brokerage;
  let tmp;
  tmp = typeof match !== "object" ? validators.brokerage.validate(input) : match._0;
  let match$1 = fieldsStatuses.website;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.website.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.licenseNumber;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.licenseNumber.validate(input) : match$2._0;
  let match$3 = fieldsStatuses.lastName;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.lastName.validate(input) : match$3._0;
  let match$4 = fieldsStatuses.firstName;
  let tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.firstName.validate(input) : match$4._0;
  let brokerageResult = tmp;
  let brokerageResult$1;
  if (brokerageResult.TAG === "Ok") {
    let websiteResult = tmp$1;
    if (websiteResult.TAG === "Ok") {
      let licenseNumberResult = tmp$2;
      if (licenseNumberResult.TAG === "Ok") {
        let lastNameResult = tmp$3;
        if (lastNameResult.TAG === "Ok") {
          let firstNameResult = tmp$4;
          if (firstNameResult.TAG === "Ok") {
            return {
              TAG: "Valid",
              output: {
                firstName: firstNameResult._0,
                lastName: lastNameResult._0,
                licenseNumber: licenseNumberResult._0,
                website: websiteResult._0,
                brokerage: brokerageResult._0
              },
              fieldsStatuses: {
                brokerage: {
                  TAG: "Dirty",
                  _0: brokerageResult,
                  _1: "Shown"
                },
                website: {
                  TAG: "Dirty",
                  _0: websiteResult,
                  _1: "Shown"
                },
                licenseNumber: {
                  TAG: "Dirty",
                  _0: licenseNumberResult,
                  _1: "Shown"
                },
                lastName: {
                  TAG: "Dirty",
                  _0: lastNameResult,
                  _1: "Shown"
                },
                firstName: {
                  TAG: "Dirty",
                  _0: firstNameResult,
                  _1: "Shown"
                }
              },
              collectionsStatuses: undefined
            };
          }
          brokerageResult$1 = brokerageResult;
        } else {
          brokerageResult$1 = brokerageResult;
        }
      } else {
        brokerageResult$1 = brokerageResult;
      }
    } else {
      brokerageResult$1 = brokerageResult;
    }
  } else {
    brokerageResult$1 = brokerageResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      brokerage: {
        TAG: "Dirty",
        _0: brokerageResult$1,
        _1: "Shown"
      },
      website: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      licenseNumber: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      lastName: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$4,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurBrokerageField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brokerage, validators_brokerage, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: status,
              website: init.website,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurWebsiteField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.website, validators_website, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: init.brokerage,
              website: status,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLicenseNumberField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.licenseNumber, validators_licenseNumber, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: init.brokerage,
              website: init.website,
              licenseNumber: status,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLastNameField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.lastName, validators_lastName, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: init.brokerage,
              website: init.website,
              licenseNumber: init.licenseNumber,
              lastName: status,
              firstName: init.firstName
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.firstName, validators_firstName, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: init.brokerage,
              website: init.website,
              licenseNumber: init.licenseNumber,
              lastName: init.lastName,
              firstName: status
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateBrokerageField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.brokerage, state.submissionStatus, validators_brokerage, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: status,
                  website: init.website,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateWebsiteField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.website, state.submissionStatus, validators_website, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: init.brokerage,
                  website: status,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLicenseNumberField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.licenseNumber, state.submissionStatus, validators_licenseNumber, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: init.brokerage,
                  website: init.website,
                  licenseNumber: status,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLastNameField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: init.brokerage,
                  website: init.website,
                  licenseNumber: init.licenseNumber,
                  lastName: status,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: init.brokerage,
                  website: init.website,
                  licenseNumber: init.licenseNumber,
                  lastName: init.lastName,
                  firstName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateBrokerage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBrokerageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateWebsite: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateWebsiteField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLicenseNumber: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLicenseNumberField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurBrokerage: () => dispatch("BlurBrokerageField"),
    blurWebsite: () => dispatch("BlurWebsiteField"),
    blurLicenseNumber: () => dispatch("BlurLicenseNumberField"),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
    websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
    licenseNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.licenseNumber),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.brokerage;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.website;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.licenseNumber;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.lastName;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.firstName;
      return typeof tmp$4 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = AgentMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialInputFromFragment(fragment) {
  return {
    firstName: fragment.firstName,
    lastName: fragment.lastName,
    licenseNumber: Stdlib_Option.getOr(fragment.licenseNumber, ""),
    website: Stdlib_Option.getOr(Stdlib_Option.map(fragment.website, Scalars.URL.toString), ""),
    brokerage: Stdlib_Option.getOr(fragment.brokerage, "")
  };
}

function messageToString(v) {
  if (v === "IsRequired") {
    return "is required";
  } else {
    return "must be a valid URL";
  }
}

function AgentMarketingProfileBasicInfoSettings$Form$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: AgentMarketingProfileBasicInfoSettings$Form$FieldValidationMessage
};

function AgentMarketingProfileBasicInfoSettings$Form$InputField(props) {
  let status = props.status;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null),
          JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$FieldValidationMessage, {
            result: status
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: AgentMarketingProfileBasicInfoSettings$Form$InputField
};

function AgentMarketingProfileBasicInfoSettings$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let form = useForm(initialInputFromFragment(marketingProfile), (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        brokerage: param.brokerage,
        firstName: param.firstName,
        lastName: param.lastName,
        licenseNumber: param.licenseNumber,
        website: param.website
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateAgentMarketingProfileBasicInfo;
      if (result !== undefined && result.__typename === "AgentMarketingProfileBasicInfoUpdated") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure();
      }
    }, param => notifyOnFailure(), undefined);
  });
  let match$1 = form.status;
  let tmp;
  tmp = typeof match$1 !== "object" ? (
      match$1 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Your account was updated"
        })
    ) : (
      match$1.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Alert.$$Error.make, {
            title: "There was an error updating your account. Please try again"
          }),
          className: "mt-4"
        })
    );
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateFirstName((input, value) => ({
                firstName: value,
                lastName: input.lastName,
                licenseNumber: input.licenseNumber,
                website: input.website,
                brokerage: input.brokerage
              }), event.target.value),
              onBlur: param => form.blurFirstName(),
              value: form.input.firstName,
              status: form.firstNameResult,
              labelText: "First name"
            }),
            JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateLastName((input, value) => ({
                firstName: input.firstName,
                lastName: value,
                licenseNumber: input.licenseNumber,
                website: input.website,
                brokerage: input.brokerage
              }), event.target.value),
              onBlur: param => form.blurLastName(),
              value: form.input.lastName,
              status: form.lastNameResult,
              labelText: "Last name"
            }),
            JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateLicenseNumber((input, value) => ({
                firstName: input.firstName,
                lastName: input.lastName,
                licenseNumber: value,
                website: input.website,
                brokerage: input.brokerage
              }), event.target.value),
              onBlur: param => form.blurLicenseNumber(),
              value: form.input.licenseNumber,
              status: form.licenseNumberResult,
              labelText: "License number"
            }),
            JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateBrokerage((input, value) => ({
                firstName: input.firstName,
                lastName: input.lastName,
                licenseNumber: input.licenseNumber,
                website: input.website,
                brokerage: value
              }), event.target.value),
              onBlur: param => form.blurBrokerage(),
              value: form.input.brokerage,
              status: form.brokerageResult,
              labelText: "Brokerage"
            }),
            JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form$InputField, {
              onChange: event => form.updateWebsite((input, value) => ({
                firstName: input.firstName,
                lastName: input.lastName,
                licenseNumber: input.licenseNumber,
                website: value,
                brokerage: input.brokerage
              }), event.target.value),
              onBlur: param => form.blurWebsite(),
              value: form.input.website,
              status: form.websiteResult,
              labelText: "Website"
            })
          ],
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              children: "View Profile"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: form.submitting,
                  children: "Save changes"
                }),
                JsxRuntime.jsx("div", {
                  children: tmp,
                  role: "status"
                })
              ],
              className: "flex flex-col items-end gap-3"
            })
          ],
          className: "flex justify-between items-baseline"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Config: Config,
  Fragment: Fragment,
  Mutation: Mutation,
  initialInputFromFragment: initialInputFromFragment,
  messageToString: messageToString,
  FieldValidationMessage: FieldValidationMessage,
  InputField: InputField,
  make: AgentMarketingProfileBasicInfoSettings$Form
};

function AgentMarketingProfileBasicInfoSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  let breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("BasicInfo"),
      href: MarketingProfileSubpages.Page.Agent.path("BasicInfo")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("BasicInfo"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: AgentMarketingProfileBasicInfoSettings$Header
};

let convertVariables$1 = AgentMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = AgentMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = AgentMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(AgentMarketingProfileBasicInfoSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfileBasicInfoSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Header, {}),
          JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = AgentMarketingProfileBasicInfoSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
